import { Button, Card, Radio } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { getGateOutcome, TGateAnswers } from './QualificationGate.helpers';
import styles from './QualificationGate.module.css';

const LOAN_APPLICATION_URL = 'https://www.iwoca.de/kreditwunsch/';

type TProps = {
  answers: TGateAnswers;
  onChange: (answers: TGateAnswers) => void;
  disabled?: boolean;
};

export const QualificationGate = ({
  answers,
  onChange,
  disabled = false,
}: TProps) => {
  const isDisqualified = getGateOutcome(answers) === 'disqualified';

  return (
    <>
      <Card className={styles.card}>
        <fieldset className={styles.question}>
          <legend className={styles.legend}>
            <Trans>Do you have a trade licence under § 34c?</Trans>
          </legend>
          <div className={styles.radioOptions}>
            <Radio
              variant="frame"
              wrapperClassName={styles.radio}
              name="hasLicence"
              checked={answers.hasLicence === true}
              disabled={disabled}
              onChange={() => onChange({ ...answers, hasLicence: true })}
              label={t`Yes`}
            />
            <Radio
              variant="frame"
              wrapperClassName={styles.radio}
              name="hasLicence"
              checked={answers.hasLicence === false}
              disabled={disabled}
              onChange={() => onChange({ ...answers, hasLicence: false })}
              label={t`No`}
            />
          </div>
        </fieldset>
        <fieldset className={styles.question}>
          <legend className={styles.legend}>
            <Trans>
              Do you have business customers you can refer to iwoca?
            </Trans>
          </legend>
          <div className={styles.radioOptions}>
            <Radio
              variant="frame"
              wrapperClassName={styles.radio}
              name="hasReferrals"
              checked={answers.hasReferrals === true}
              disabled={disabled}
              onChange={() => onChange({ ...answers, hasReferrals: true })}
              label={t`Yes`}
            />
            <Radio
              variant="frame"
              wrapperClassName={styles.radio}
              name="hasReferrals"
              checked={answers.hasReferrals === false}
              disabled={disabled}
              onChange={() => onChange({ ...answers, hasReferrals: false })}
              label={t`No`}
            />
          </div>
        </fieldset>
      </Card>
      {isDisqualified && (
        <Card
          className={styles.disqualifiedCard}
          data-testid="disqualified-message"
        >
          <p className={styles.disqualifiedText}>
            <Trans>
              Looking for a loan for your own business and don't want to act as
              an introducer? Make a request{' '}
              <a href={LOAN_APPLICATION_URL} target="_blank" rel="noreferrer">
                here
              </a>
              .
            </Trans>
          </p>
          <p className={styles.disqualifiedText}>
            <Trans>
              For more information, send us an email at partner@iwoca.de.
            </Trans>
          </p>
          <Button
            variant="primary"
            href="mailto:partner@iwoca.de"
            className={styles.disqualifiedButton}
          >
            <Trans>Email partner@iwoca.de</Trans>
          </Button>
        </Card>
      )}
    </>
  );
};
